import React from "react";
import "./index.css";

const Send = () => {
  return (
    <div className="fullH send">
      <div className="container-sm">
        <div className="colorBox flex flexRow">
          <div className="textCol flex flexCol justifyCenter">
            <h1 className="relative">
              Thank you!
              <br />
              <span>We receive your request.</span>
            </h1>
            <h3 className="relative">
              Our team will respond to you as soon as possible..
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Send;
